import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Icon } from '@modulor/react';
import Local from '../../../Local/Local';
import { LinkWithAnalytics } from '../../../Link/Link';
import { getDataTestAttrs } from '../../../../utils/testing-locators';
import { NAMESPACES } from '../../../../constants/namespaces';
import { NAVIGATION_SECTION_LINK } from '../../../../constants/dataTestIds';
import styles from './NavigationTitle.module.css';

const NavigationTitle = ({
  title,
  link,
  className,
  analyticsData,
  ...props
}) => (
  <LinkWithAnalytics
    to={link}
    className={classNames(styles.component_ig, className)}
    {...getDataTestAttrs(NAVIGATION_SECTION_LINK, link)}
    analyticsData={analyticsData}
    {...props}
  >
    <span className={styles.title_ig}>{title}</span>
    <span className={styles.all_ig}>
      <span className={styles.all_text_ig}>
        <Local namespace={NAMESPACES.INITIAL}>All</Local>
      </span>
      <Icon className={styles.all_icon_ig} name="chevron_right" />
    </span>
  </LinkWithAnalytics>
);

NavigationTitle.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.element,
    PropTypes.string,
  ]).isRequired,
  link: PropTypes.string.isRequired,
  analyticsData: PropTypes.shape({
    schema: PropTypes.string,
    name: PropTypes.string,
    screen_name: PropTypes.string,
    screen_area: PropTypes.string,
    screen_area_detail: PropTypes.string,
    section_index: PropTypes.number,
  }),
};

NavigationTitle.defaultProps = {
  analyticsData: {},
};

export default NavigationTitle;
